import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scale } from "lucide-react";

const Termini = () => (
    <div className="max-w-3xl mx-auto space-y-6 text-elegant text-sm leading-relaxed" data-testid="termini-page">
        <Link to="/dashboard" className="inline-flex items-center gap-2 text-brand hover:underline text-sm">
            <ArrowLeft className="w-4 h-4" /> Torna alla dashboard
        </Link>
        <div>
            <div className="text-xs uppercase tracking-[0.3em] text-brand mb-2">Documento</div>
            <h1 className="font-display text-4xl font-bold text-warm flex items-center gap-3">
                <Scale className="w-9 h-9 text-brand" /> Termini & Condizioni
            </h1>
            <div className="text-xs text-elegant mt-2">Ultimo aggiornamento: 8 maggio 2026</div>
        </div>
        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">1. Fornitore</h2>
            <p>Smart Table è un servizio fornito da <strong className="text-warm">MAKAI di Maria Laura Pellino</strong>, P.IVA 09936410969.</p>
        </section>
        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">2. Servizio</h2>
            <p>Smart Table è una piattaforma SaaS di gestione ristorante che include: gestione tavoli, prenotazioni, ordini, cucina, cassa, integrazione renova360.</p>
        </section>
        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">3. Abbonamento e prova gratuita</h2>
            <p>L'utilizzo richiede un abbonamento attivo. È disponibile un periodo di prova gratuita di 10 giorni. Al termine del trial, l'accesso è subordinato al pagamento del canone.</p>
        </section>
        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">4. Limitazione di responsabilità</h2>
            <p>Smart Table è uno strumento gestionale. Il ristoratore resta unico responsabile della correttezza dei dati fiscali emessi e della conformità alla normativa fiscale italiana (es. trasmissione corrispettivi). MAKAI non risponde di errori di compilazione o uso improprio del sistema.</p>
        </section>
        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">5. Foro competente</h2>
            <p>Per ogni controversia è competente il Foro di Napoli.</p>
        </section>
    </div>
);

export default Termini;
